import type { TrustGroupUserDto } from "@/models/dto/trustGroupUserDto";
import { getIsCustomer, removeUserFromTrustGroup } from "@/services/trustGroupService";
import { defineStore } from "pinia";

export interface ITrustGroupState {
  isCustomer: boolean;
  loading: boolean;
}

export const useTrustGroupStore = defineStore("trust-group", {
  state: (): ITrustGroupState => ({
    isCustomer: false,
    loading: true,
  }),

  actions: {
    async setIsCustomer(): Promise<void> {
      this.isCustomer = await getIsCustomer();
    },

    async removeUserFromTrustGroup(user: TrustGroupUserDto): Promise<void> {
      this.loading = true;
      try {
        await removeUserFromTrustGroup(user);
      } catch (error: any) {
        throw new Error(error.response.data.Message);
      }
    }
  },
});
